import React from 'react';
import { Link } from 'react-router-dom';

/**
 * Slim, theme-styled footer for the public pages (login / signup / pricing) and
 * the legal pages themselves. Links to the Privacy Policy and Terms pages.
 */
const LegalFooter: React.FC = () => (
  <footer style={footerStyle}>
    <nav style={navStyle}>
      <Link to="/privacy" style={linkStyle}>Privacy Policy</Link>
      <span style={dotStyle}>·</span>
      <Link to="/terms" style={linkStyle}>Terms &amp; Conditions</Link>
      <span style={dotStyle}>·</span>
      <a href="mailto:team@coldcallkillers.io" style={linkStyle}>team@coldcallkillers.io</a>
    </nav>
    <div style={copyStyle}>© 2026 Cold Call Killers · Dial Sniper™</div>
  </footer>
);

const footerStyle: React.CSSProperties = {
  marginTop: 20,
  paddingTop: 14,
  borderTop: '1px solid var(--border-subtle)',
  textAlign: 'center',
};
const navStyle: React.CSSProperties = {
  display: 'flex',
  flexWrap: 'wrap',
  justifyContent: 'center',
  alignItems: 'center',
  gap: 8,
};
const linkStyle: React.CSSProperties = {
  color: 'var(--text-faint)',
  fontSize: 12,
  textDecoration: 'none',
  letterSpacing: '0.04em',
};
const dotStyle: React.CSSProperties = { color: 'var(--text-faint)', fontSize: 12 };
const copyStyle: React.CSSProperties = {
  marginTop: 8,
  color: 'var(--text-faint)',
  fontSize: 11,
  letterSpacing: '0.06em',
};

export default LegalFooter;
